// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_document_support_banner_app__wBNYz"};